import BankCodeInput from "./bankCodeInput";

export default class SwiftInput<TTarget> extends BankCodeInput<TTarget> {
  // SWIFT/BIC - 8 or 11 alpha numeric chars
  protected mask = Array.from(Array(11).keys()).map(key => {
    return /[A-Z]|[a-z]|[0-9]/;
  });
}
